import { render, staticRenderFns } from "./CloneGrade.vue?vue&type=template&id=6434b46a&scoped=true"
import script from "./CloneGrade.vue?vue&type=script&lang=js"
export * from "./CloneGrade.vue?vue&type=script&lang=js"
import style0 from "./CloneGrade.vue?vue&type=style&index=0&id=6434b46a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6434b46a",
  null
  
)

export default component.exports